import React from "react"
import { cn } from "utils";

// color = "primary" | "white"
const Select = React.forwardRef(({
    options = [],
    className,
    containerClasses,
    fullWidth = false,
    label,
    placeholder = "Select",
    color = 'primary',
    required = false,
    error = false,
    errorText = "",
    ...rest
}, ref) => {
    const { value, onChange, ...restProps } = rest;
    const isControlled = value !== undefined && onChange != null;
    return (
        <div className={cn("select-container", fullWidth ? "full" : "", containerClasses)}>
            {label && (
                <label>
                    {label}{required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
                </label>
            )}
            <select
                ref={ref}
                {...(isControlled ? { value } : { defaultValue: value ?? "" })}
                onChange={onChange}
                className={cn("select-base", color, error ? "error" : "", className)}
                {...restProps}
            >
                {placeholder && (
                    <option value="">{placeholder}</option>
                )}
                {options.map((option, index) => {
                    return (
                        <option
                            key={option?.value ?? index}
                            value={option?.value}
                        >
                            {option?.label}
                        </option>
                    )
                })}
            </select>
            {errorText && (<p className="error-text">{errorText}</p>)}
        </div>
    )
});

Select.displayName = "Select";

export default Select

